import React, { useEffect, useState } from "react";


import { updateMxHeader } from "@trailhead/mx-header";
import { updateStickyProps } from "@trailhead/analytics";
import { useMxContext } from "@trailhead/mx-context";
import { useSanitizedTranslation } from "@trailhead/i18n";
import {
  ContentBlock,
  Metadata,
  PartnerType,
  useContentfulData,
} from "@trailhead/contentful";
import { useNavigate, useQueryParams } from "@trailhead/smart-setup-core";
import { TransitionWrapper } from "@trailhead/core-ui";

import { DefaultSmartSetup } from "./DefaultSmartSetup";
import { VerizonSmartSetup } from "./VerizonSmartSetup";

export const SmartSetupIntro: React.FC = () => {
  const t = useSanitizedTranslation();
  const navigateTo = useNavigate();
  const hubUrl = new URL("https://my.asurion.com");

  const { client, language } = useMxContext();
  const [isLoaded, setIsLoaded] = useState(false);

  const queryParams = useQueryParams();
  const cid = queryParams.get("cid");

  const isVerizonSmartSetup =
    client === PartnerType.VERIZON &&
    (cid === "vz_bu_ss" || cid === "vz_su_ss");

  //left to preserve analytic from previous implementation
  updateStickyProps({ wasRedirected: false });
  useContentfulData<ContentBlock & Metadata>(
    "contentBlock",
    client,
    language,
    queryParams.get("isPreview"),
  );

  updateMxHeader({
    view: "service-view",
    title: t("Mobile Device Set Up"),
    backTitle: t("Home"),
    onBack: () => {
      const cidParam = !!cid ? `&cid=${cid}` : "";
      const homepath = `${hubUrl.pathname}${hubUrl.search}${cidParam}`;
      navigateTo(homepath, { preserveQueryParams: false });
    },
    homePath: hubUrl.toString(),
    client,
  });

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 700);
  }, []);

  return (
    <TransitionWrapper isLoaded={isLoaded}>
      {isVerizonSmartSetup ? <VerizonSmartSetup /> : <DefaultSmartSetup />}
    </TransitionWrapper>
  );
};

export default SmartSetupIntro;
